import { useState } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ExternalLink, Play } from "lucide-react";

const SeriesJaponesas = () => {
  const [activeTab, setActiveTab] = useState("todas");

  // Lista de séries agrupadas por categorias
  const series = {
    tokusatsu: [
      {
        title: "Gaoranger",
        link: "https://gokagen.comunidades.net/serie-gaoranger2",
        description: "Hyakujuu Sentai Gaoranger é uma série Super Sentai que apresenta um tema de animais selvagens.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-JLY9XMjJpDJlMTq5WUHSJ9nJ.png?st=2023-07-23T22%3A16%3A54Z&se=2023-07-24T00%3A16%3A54Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A48%3A54Z&ske=2023-07-24T22%3A48%3A54Z&sks=b&skv=2021-08-06&sig=Xw%2BjIJsltWCy6wbxPCMjZcljZX9SuKs7TuCxzGv3lPk%3D"
      },
      {
        title: "Larva Rangers",
        link: "https://gokagen.comunidades.net/serie-larva-rangers",
        description: "Uma série de super-heróis inspirada no estilo Super Sentai mas com tema de larvas.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-KH4unE3jbDSAF8Nhj4ELkWJN.png?st=2023-07-23T22%3A18%3A15Z&se=2023-07-24T00%3A18%3A15Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T23%3A11%3A31Z&ske=2023-07-24T23%3A11%3A31Z&sks=b&skv=2021-08-06&sig=kLXwNH7wlnrAhH/QHnMhCiKRpTbvqK1ZD7nXbJ60LQU%3D"
      },
      {
        title: "Shark League Granzale",
        link: "https://gokagen.comunidades.net/serie-shark-league-granzale",
        description: "Série com temática de tubarões e oceano, uma aventura única no mundo tokusatsu.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-DFNQRrT4WBTsfbGRD6ht2mbL.png?st=2023-07-23T22%3A19%3A14Z&se=2023-07-24T00%3A19%3A14Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A57%3A07Z&ske=2023-07-24T22%3A57%3A07Z&sks=b&skv=2021-08-06&sig=Oap5JnkZnYj2DvVLDWMVpWzjwB8N8KFPN2fkVVjZJbA%3D"
      },
      {
        title: "Akibaranger",
        link: "https://gokagen.comunidades.net/serie-akibaranger",
        description: "Uma paródia não-oficial da franquia Super Sentai, com foco em cultura otaku.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-fYYGHbcZvCqTqIkBm2cqZgRD.png?st=2023-07-23T22%3A21%3A11Z&se=2023-07-24T00%3A21%3A11Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A53%3A18Z&ske=2023-07-24T22%3A53%3A18Z&sks=b&skv=2021-08-06&sig=X6BzKTG0R8/q%2BkTTxw6eBZZn9Hy7wmIbQQKXbQQvVnQ%3D"
      },
      {
        title: "Gosenger",
        link: "https://gokagen.comunidades.net/serie-gosengeir",
        description: "Uma série Super Sentai com tema de anjos e cartas, repleta de ação e aventura.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-YXdEHcuMsIj0x9Vq9k9iEU0y.png?st=2023-07-23T22%3A22%3A01Z&se=2023-07-24T00%3A22%3A01Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A21%3A52Z&ske=2023-07-24T22%3A21%3A52Z&sks=b&skv=2021-08-06&sig=LNibPhfxBX5ZgNkK3UYp9hVe9ZPBf8Zo89mvQ/HNABY%3D"
      },
      {
        title: "Machine Man",
        link: "https://gokagen.comunidades.net/serie-machine-man",
        description: "Série clássica com tema de robôs e máquinas, uma das pioneiras do gênero no Japão.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-WNWFr3XBIcfj3H8WKR1B1Xfv.png?st=2023-07-23T22%3A22%3A57Z&se=2023-07-24T00%3A22%3A57Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A54%3A47Z&ske=2023-07-24T22%3A54%3A47Z&sks=b&skv=2021-08-06&sig=JKp0ZI3hMnlRdAXxPiPIKIc4nR6BL6QqHgEt7aaQlXE%3D"
      }
    ],
    ultraman: [
      {
        title: "Ultraman (Coleção Completa)",
        link: "https://gokagen.comunidades.net/utraman-todos-completao",
        description: "Coleção completa da franquia Ultraman, incluindo todas as séries clássicas e modernas.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-s1oYrz3VVnYBnwDTdtZXCOvv.png?st=2023-07-23T22%3A23%3A46Z&se=2023-07-24T00%3A23%3A46Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A54%3A23Z&ske=2023-07-24T22%3A54%3A23Z&sks=b&skv=2021-08-06&sig=TtpsfQ5G8vXavEcXRsHBBdTzDJqXzYimUzWCWJ%2B4Evc%3D"
      }
    ],
    lutadores: [
      {
        title: "Super Street Fighter 2",
        link: "https://gokagen.comunidades.net/super-street-fighter-2",
        description: "Série baseada no famoso jogo de luta da Capcom, com episódios emocionantes.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-9yMkUPK5cjLIyLfOwCIZCvwH.png?st=2023-07-23T22%3A24%3A41Z&se=2023-07-24T00%3A24%3A41Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A57%3A24Z&ske=2023-07-24T22%3A57%3A24Z&sks=b&skv=2021-08-06&sig=oP3iZfbVskF/OKoJjGxDEYwVEfyJVBdMXpHdCBTqpAk%3D"
      },
      {
        title: "A História da Morte de Bruce Lee",
        link: "https://gokagen.comunidades.net/a-historia-da-morte-de-bruce-lee",
        description: "Documentário especial sobre a vida e misteriosa morte do lendário Bruce Lee.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-WdvpL5ohrUmPCYSRCCcmD9C1.png?st=2023-07-23T22%3A25%3A37Z&se=2023-07-24T00%3A25%3A37Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A18%3A20Z&ske=2023-07-24T22%3A18%3A20Z&sks=b&skv=2021-08-06&sig=xnOSgUU%2BU1wSMdMbzZLxGSKHZbG6B%2Bi0UmAcRkVpKKs%3D"
      },
      {
        title: "Street Fighter Alpha: Ryu vs. Sagat (Live Action)",
        link: "https://gokagen.comunidades.net/street-fighter-alpha-ryu-vs-sagat-live-action",
        description: "Filme live action que recria a épica batalha entre Ryu e Sagat de Street Fighter Alpha.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-FJmHm9DFNLZZHUjGWLZJNLrw.png?st=2023-07-23T22%3A26%3A37Z&se=2023-07-24T00%3A26%3A37Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A28%3A25Z&ske=2023-07-24T22%3A28%3A25Z&sks=b&skv=2021-08-06&sig=4ljUcQqkuE6H2rDssK5Y/ZGlVPNZJzpW5duQYVaNUPc%3D"
      }
    ],
    coletaneas: [
      {
        title: "Rede Tokusatsu",
        link: "https://gokagen.comunidades.net/rede-tokatsu",
        description: "Coletânea de diversas séries tokusatsu clássicas e modernas.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-GxWVCFSQvmHCLCKskDFO0tUn.png?st=2023-07-23T22%3A28%3A24Z&se=2023-07-24T00%3A28%3A24Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A59%3A21Z&ske=2023-07-24T22%3A59%3A21Z&sks=b&skv=2021-08-06&sig=rEFLq%2BH9iQgqq5JdD%2B3F5gUDKKkJCf0%2B0P%2B7/7cJTHQ%3D"
      },
      {
        title: "Todas as Séries",
        link: "https://gokagen.comunidades.net/todas-as-series-japao",
        description: "Coleção completa de todas as séries japonesas disponíveis no site.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-1vKRTK6RThyiqrTAhQPELn7w.png?st=2023-07-23T22%3A29%3A16Z&se=2023-07-24T00%3A29%3A16Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A59%3A47Z&ske=2023-07-24T22%3A59%3A47Z&sks=b&skv=2021-08-06&sig=c6zXSGcqLx8iNEfcCbXo%2BGnGkKUVPzAzO3HVBPdQu8s%3D"
      },
      {
        title: "As Séries do Japão Hoje",
        link: "https://gokagen.comunidades.net/as-series-do-japao-hoje",
        description: "Coletânea das séries japonesas mais recentes e atuais.",
        image: "https://oaidalleapiprodscus.blob.core.windows.net/private/org-lWfRq7lTWdcxS4jVWepETn68/user-fBaQRiYvYJDQQtOZwVn4TQez/img-IG9P3CUgRbQZu5P9rYC1rjhx.png?st=2023-07-23T22%3A30%3A07Z&se=2023-07-24T00%3A30%3A07Z&sp=r&sv=2021-08-06&sr=b&rscd=inline&rsct=image/png&skoid=6aaadede-4fb3-4698-a8f6-684d7786b067&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skt=2023-07-23T22%3A52%3A53Z&ske=2023-07-24T22%3A52%3A53Z&sks=b&skv=2021-08-06&sig=RvyAWqMNpAuoK0rP7R1b1W3AEwPwpWDRu4qrAbnLTY8%3D"
      }
    ]
  };

  // Função para obter todas as séries em uma única lista
  const getAllSeries = () => {
    const allSeries = [];
    Object.keys(series).forEach(category => {
      series[category].forEach(serie => {
        allSeries.push(serie);
      });
    });
    return allSeries;
  };

  // Função para renderizar um card de série
  const SerieCard = ({ serie }) => (
    <Card className="overflow-hidden transition-all hover:shadow-lg">
      <div className="aspect-video w-full overflow-hidden">
        <img 
          src={serie.image} 
          alt={serie.title} 
          className="h-full w-full object-cover transition-transform hover:scale-105"
        />
      </div>
      <CardHeader>
        <CardTitle>{serie.title}</CardTitle>
        <CardDescription>{serie.description}</CardDescription>
      </CardHeader>
      <CardFooter className="flex justify-between">
        <Button variant="outline" onClick={() => window.open(serie.link, "_blank")}>
          <ExternalLink className="mr-2 h-4 w-4" />
          Visitar Site
        </Button>
        <Button onClick={() => window.open(serie.link, "_blank")}>
          <Play className="mr-2 h-4 w-4" />
          Assistir
        </Button>
      </CardFooter>
    </Card>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow pt-20 p-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 text-center">
            <h1 className="text-4xl font-bold mb-4">As Melhores Séries do Japão</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Uma coleção completa das séries japonesas mais icônicas, incluindo tokusatsu, 
              Super Sentai, Ultraman e muito mais.
            </p>
          </div>
          
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <div className="flex justify-center mb-8">
              <TabsList className="grid grid-cols-2 md:grid-cols-5 gap-2">
                <TabsTrigger value="todas">Todas</TabsTrigger>
                <TabsTrigger value="tokusatsu">Tokusatsu</TabsTrigger>
                <TabsTrigger value="ultraman">Ultraman</TabsTrigger>
                <TabsTrigger value="lutadores">Lutadores</TabsTrigger>
                <TabsTrigger value="coletaneas">Coletâneas</TabsTrigger>
              </TabsList>
            </div>
            
            <TabsContent value="todas">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {getAllSeries().map((serie, index) => (
                  <SerieCard key={index} serie={serie} />
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="tokusatsu">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {series.tokusatsu.map((serie, index) => (
                  <SerieCard key={index} serie={serie} />
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="ultraman">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {series.ultraman.map((serie, index) => (
                  <SerieCard key={index} serie={serie} />
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="lutadores">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {series.lutadores.map((serie, index) => (
                  <SerieCard key={index} serie={serie} />
                ))}
              </div>
            </TabsContent>
            
            <TabsContent value="coletaneas">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {series.coletaneas.map((serie, index) => (
                  <SerieCard key={index} serie={serie} />
                ))}
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SeriesJaponesas;